/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Pending_Desc_BadgeInputs */

const en_directory_submit_enrich_pending_desc_badge = /** @type {(inputs: Directory_Submit_Enrich_Pending_Desc_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your listing is in the review queue and goes live with a dofollow link once approved. Fast Track publishes it right now.`)
};

const zh_directory_submit_enrich_pending_desc_badge = /** @type {(inputs: Directory_Submit_Enrich_Pending_Desc_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的条目已进入审核队列，通过后以 dofollow 外链上线。快速上线可立即发布。`)
};

/**
* | output |
* | --- |
* | "Your listing is in the review queue and goes live with a dofollow link once approved. Fast Track publishes it right now." |
*
* @param {Directory_Submit_Enrich_Pending_Desc_BadgeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_pending_desc_badge = /** @type {((inputs?: Directory_Submit_Enrich_Pending_Desc_BadgeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Pending_Desc_BadgeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_pending_desc_badge(inputs)
	return zh_directory_submit_enrich_pending_desc_badge(inputs)
});
export { directory_submit_enrich_pending_desc_badge as "directory.submit.enrich.pending_desc_badge" }